import { VFC } from 'react'
import styles from '../../assets/components/atoms/BaseButton.module.scss'
import { BASEBUTTONPROPS } from './types/BaseButton.types'

export const BaseButton: VFC<BASEBUTTONPROPS> = ({ label, eventClick }) => {
    return (
        <>
            <div className={ styles.button_container }>
                <button onClick={ eventClick }>{ label }</button>
            </div>
        </>
    );
}